import {ComponentBase} from "../../../_snowpack/link/dist/@salaxy/ng1/salaxy-lib-ng1.js";
import {WorkflowBadgeProController} from "../../controllers/pro/index.js";
export class ProWorkflowBadge extends ComponentBase {
  constructor() {
    super(...arguments);
    this.bindings = {
      entityType: "<",
      model: "<",
      wfTypes: "<",
      accountId: "<"
    };
    this.controller = WorkflowBadgeProController;
    this.defaultTemplate = "salaxy-components/workflow/WorkflowBadge.html";
  }
}
